import axiosInstance from './axiosInstance';

export const getWallet = async () => {
  const response = await axiosInstance.get('/loyalty/wallet');
  return response.data;
};

export const getUserCards = async () => {
  const response = await axiosInstance.get('/loyalty/cards');
  return response.data;
};

export const purchaseLoyaltyCard = async (cardType) => {
  const response = await axiosInstance.post(`/loyalty/cards/purchase?cardType=${cardType}`);
  return response.data;
};

export const getTransactions = async () => {
  const response = await axiosInstance.get('/loyalty/transactions');
  return response.data;
};